import FetchFactory from '../factory'

interface IUpload {
  body: {
    type: string
    file: string
  }
}

interface IAssociateFile {
  body: {
    media_ids: Array<number>
  }
}

interface IDeleteFile {
  params: {
    media_id: string | number
  }
}
class MediaModule extends FetchFactory<any> {
    async uploadImages(payload: IUpload) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/media/upload/images', {
                method: 'POST',
                body
            })
        })
    }

    async uploadDocuments(payload: IUpload) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/media/upload/documents', {
                method: 'POST',
                body,
                headers: {
                    Accept: 'multipart/form-data',
        }
            })
        })
    }

    async associateFiles(payload: IAssociateFile) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/media/associate', {
                method: 'POST',
                body
            })
        })
    }

    async deleteFile(payload: IDeleteFile) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(`/api/media/${params.media_id}`, {
                method: 'DELETE',
      })
        })
    }
}

export default MediaModule
